// BP 56 §6 — locale negotiation, step 3: first base-tag match of
// `navigator.languages` against the 5 supported locales (`de-AT` -> `de`,
// `da-DK` -> `da`), else `en`. Kept as a small pure function (no store / no
// i18next import) so it's trivial to eyeball or unit-test in isolation; the
// full 4-step precedence (user.locale -> localStorage -> this -> en) is
// assembled in `index.ts` / `authStore.ts` from pieces that already carry
// steps 1/2/4 (the auth payload, the persisted localeStore, DEFAULT_LOCALE).

import { DEFAULT_LOCALE, isSupportedUiLocale, type UiLocale } from './constants';

export function negotiateFromNavigator(): UiLocale {
  const languages = typeof navigator !== 'undefined' ? navigator.languages : undefined;
  if (!languages || languages.length === 0) return DEFAULT_LOCALE;
  for (const tag of languages) {
    const base = tag.toLowerCase().split('-')[0];
    if (isSupportedUiLocale(base)) return base;
  }
  return DEFAULT_LOCALE;
}
